import { lenis } from './modules/Lenis';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const validateEmail = email => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const getScrollbarWidth = () => {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
};

export const disableScroll = () => {
    if (ScrollTrigger.isTouch == 1) return;
    const scrollbarWidth = getScrollbarWidth();
    lenis.stop();
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    document.querySelector(
        '.header'
    ).style.width = `calc(100% - ${scrollbarWidth}px)`;
};

export const enableScroll = () => {
    if (ScrollTrigger.isTouch == 1) return;
    lenis.start();
    document.body.style.paddingRight = '';
    document.querySelector('.header').style.width = '100%';
};

export const capitalizeWords = str =>
    str.replace(/\b\w/g, char => char.toUpperCase());
